import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

/** 消息中心代码加载时保留分类、状态标签和初始加载区，不提前展示消息行 */
export function MessageCenterSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <Card className="min-h-[750px] flex-row overflow-hidden p-0 gap-0">
        {/** 全部、系统、开户和资金消息分类 */}
        <div className="w-[160px] border-r py-6 flex-shrink-0">
          <div className="flex flex-col gap-1 px-2">
            {Array.from({ length: 4 }, (_, index) => (
              <div key={index} className={cn('px-10 py-3 rounded-full', index === 0 && 'bg-muted/80')}>
                <Skeleton className="h-5 w-14 bg-foreground/10" />
              </div>
            ))}
          </div>
        </div>

        <div className="flex-1 flex flex-col min-w-0">
          {/** 全选占位、全部／已读／未读标签及批量标记入口 */}
          <div className="px-8 pt-6 border-b flex items-center justify-between relative">
            <div className="flex items-center gap-4">
              <div className="flex items-center -ml-4 pr-2 pb-2">
                <Skeleton className="h-4 w-4" />
              </div>
              <div className="flex w-fit items-center gap-8">
                {Array.from({ length: 3 }, (_, index) => (
                  <div key={index} className="px-1 pt-1 pb-2 border-b-2 border-transparent">
                    <Skeleton className="h-6 w-8" />
                  </div>
                ))}
              </div>
            </div>
            <Skeleton className="h-5 w-28" />
          </div>

          {/** 首次请求尚无消息，保留居中的加载提示位置 */}
          <div className="flex-1 overflow-hidden">
            <div className="flex flex-col items-center justify-center h-full">
              <Skeleton className="h-6 w-20" />
            </div>
          </div>

          {/** 初始总数为零，仅预留记录总数而不展示翻页控件 */}
          <div className="px-8 py-4 border-t">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-28" />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
